/* eslint-disable no-nested-ternary */
import { useLocation, Navigate, Outlet } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const RequireManager = () => {
  const { auth } = useAuth();
  const location = useLocation();

  return auth?.roles.includes('manager') ? (
    <Outlet />
  ) : auth?.accessToken ? (
    <Navigate to='/unauthorized' state={{ from: location }} replace />
  ) : (
    <Navigate to='/login' state={{ from: location }} replace />
  );
};

export default RequireManager;
